import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Story} from "../../models/Story/Story";
import {animateShow} from "../../animations/showHideAnimation";
import {StoryService} from "../../services/storyService/story.service";
import {AbstractObserver} from "../../classes/AbstractObserver/AbstractObserver";
// import {PreloadService} from "../../services/preloadService/preload.service";

@Component({
  selector: 'app-edit-story',
  templateUrl: './edit-story.component.html',
  styleUrls: ['./edit-story.component.scss'],
  animations: [animateShow]
})
export class EditStoryComponent extends AbstractObserver implements OnInit {

  @Input() story: Story;
  // @Output() renameStory = new EventEmitter<any>();
  @Output() onOpenedChanged = new EventEmitter<any>();
  public isOpened = false;
  public Yiit = Yiit;

  constructor(private storyAdapter: StoryService, private cd: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    this.subscribeToObservable(this.storyAdapter.currentStory$, (story)=>{
        if (!story || story.id.toString().toLowerCase()!==this.story.id.toString().toLowerCase()){
          this.isOpened = false;
          this.cd.detectChanges();
        }
    })

    this.subscribeToObservable(this.storyAdapter.inActivateEditMenu$, ()=>{
      this.isOpened = false;
      this.onOpenedChanged.emit(this.isOpened);
      this.cd.detectChanges();
    })
  }

  toggleEditMenu(e){
    if (this.isOpened){
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
    this.isOpened = !this.isOpened;
    this.onOpenedChanged.emit(this.isOpened);
    this.cd.detectChanges();
  }

  // removeStory(){
  //   if (window.confirm(Yiit.t('Are you sure?'))) {
  //     this.preload.preloadMessage$ = this.Yiit.t('Remove story');
  //     this.preload.isPreloading$ = true;
  //     this.storyAdapter.removeStory(this.story).subscribe(()=>{
  //       this.isOpened = false;
  //       this.onOpenedChanged.next(this.isOpened);
  //       this.preload.isPreloading$ = false;
  //       if (!this.cd['destroyed']) {
  //         this.cd.detectChanges();
  //       }
  //     });
  //   }
  // }
  //
  // _renameStory(e){
  //   this.isOpened = false;
  //   this.onOpenedChanged.next(this.isOpened);
  //   this.cd.detectChanges();
  //   this.renameStory.next(e)
  // }

}
